import { createRouter, createWebHistory } from "vue-router";
import SeatMap from "../components/Booking/SeatMap.vue";
import PaymentView from "../components/Booking/PaymentView.vue";
import PaymentSuccessView from "../components/Booking/PaymentSuccessView.vue";

const routes = [
  {
    path: "/",
    name: "SeatMap",
    component: SeatMap,
  },
  {
    path: "/payment/:token",
    name: "PaymentView",
    component: PaymentView,
    props: true,
  },
  {
    path: "/payment/success/:token",
    name: "PaymentSuccessView",
    component: PaymentSuccessView,
    props: true,
  },
  {
    path: "/:catchAll(.*)",
    component: () => import("../components/Booking/NotFound.vue"), // Create a simple NotFound component
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  document.title = "BusDCX - Đặt vé trekking trực tuyến dễ dàng, nhanh chóng";
  const favicon =
    document.querySelector('link[rel="icon"]') ||
    document.createElement("link");
  favicon.type = "image/x-icon";
  favicon.rel = "icon";
  favicon.href = "/favicon.ico";
  if (!document.querySelector('link[rel="icon"]')) {
    document.head.appendChild(favicon);
  }
  // const metaDescription = document.createElement("meta");
  // metaDescription.name = "description";
  // metaDescription.content =
  //   "BusDCX - Hệ thống đặt vé xe trekking, du lịch nhanh chóng! Đặt vé để có những chuyến đi khám phá đáng nhớ! Trekktogether, Live Together!";
  // document.head.appendChild(metaDescription);
  
  // const metaKeywords = document.createElement("meta");
  // metaKeywords.name = "keywords";
  // metaKeywords.content =
  //   "đặt vé trekking, trekking trực tuyến, BusDCX, dịch vụ trekking, hành trình trekking";
  // document.head.appendChild(metaKeywords);
  
  // const metaAuthor = document.createElement("meta");
  // metaAuthor.name = "author";
  // metaAuthor.content = "BusDCX Team";
  // document.head.appendChild(metaAuthor);

  // const metaCharset = document.createElement("meta");
  // metaCharset.charset = "UTF-8";
  // document.head.appendChild(metaCharset);
  
  // const metaViewport = document.createElement("meta");
  // metaViewport.name = "viewport";
  // metaViewport.content = "width=device-width, initial-scale=1.0";
  // document.head.appendChild(metaViewport);

  // const themeColorMeta = document.createElement("meta");
  // themeColorMeta.name = "theme-color";
  // themeColorMeta.content = "#ffffff";
  // document.head.appendChild(themeColorMeta);


  next();
});

export default router;
